import React from 'react';
import PropTypes from 'prop-types';
import './ButtonVersion2.css';

const ButtonVersion2 = ({
  text,
  onClick,
  disabled,
  size = 'md',
  color = 'default',
  role = 'primary',
  iconLeft = false,
  iconRight = false,
  iconUrl,
  ...props
}) => {
  const handleClick = () => {
    if (onClick) onClick();
  };

  const classNames = [
    'button-version2',
    `button--${size}`,
    `button--${role}`,
    `button--${color}`,
    disabled ? 'button--disabled' : '',
  ];

  if (role === 'primary') {
    classNames.push(`button-primary-${color}`);
  } else if (role === 'secondary') {
    classNames.push(`button-secondary-${color}`);
  } else if (role === 'subtle') {
    classNames.push(`button-subtle-${color}`);
  }

  return (
    <button
      disabled={disabled}
      className={classNames.join(' ')}
      onClick={handleClick}
      {...props}
    >
      {iconLeft && iconUrl && <img src={iconUrl} alt="icon" className="button__icon button__icon--left" />}
      <span className="button__text">{text}</span>
      {iconRight && iconUrl && <img src={iconUrl} alt="icon" className="button__icon button__icon--right" />}
    </button>
  );
};

ButtonVersion2.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  color: PropTypes.oneOf(['default', 'info', 'success', 'warning', 'danger']),
  role: PropTypes.oneOf(['primary', 'secondary', 'subtle']),
  iconLeft: PropTypes.bool,
  iconRight: PropTypes.bool,
  iconUrl: PropTypes.string,
};

export default ButtonVersion2;
